import React from "react";
import { graphql } from "gatsby";
import NavHeader from "../components/nav-header";
import SectionBreak from "../components/section-break";
import BannerImage from "../components/banner-image";
import StandardPage from "../components/standard-page";
import StandardSection from "../components/standard-section";
import Seo from "../components/seo";
import CardSearch from "../components/card-search";

export default function Destinations({
  data, // this prop will be injected by the GraphQL query below.
  location,
}) {
  return (
    <StandardPage
      header={
        <NavHeader>
          <BannerImage childImageSharp={data.file.childImageSharp} />
        </NavHeader>
      }
    >
      <StandardSection title="Destinations">
        <p className="text-center">
          Planning is hard, let me help you! Click on the destination you’re
          interested in or use the search bar to explore.
        </p>
      </StandardSection>
      <SectionBreak>
        <h1 className="uppercase text-5xl">Where would you like to travel?</h1>
      </SectionBreak>

      <CardSearch filters="type:Destination"></CardSearch>

      <Seo
        title="Destinations"
        cover={data.file}
        slug="/destinations/"
        type={false}
      />
    </StandardPage>
  );
}

export const pageQuery = graphql`
  query {
    file(relativePath: { eq: "northcascades.jpg" }) {
      publicURL
      childImageSharp {
        fluid(quality: 90, maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
